module.exports = __webpack_public_path__ + "img/lawn.b853033e.jpg";